import React from 'react';
import Plot from 'react-plotly.js';
import * as Const from '../../../utils/Const';

interface TrainingPlayTimeProps {
  data?: any; // 引数として渡すプロパティ
}

function transformToPlotlyData(sqlData: any[]) {
  if (!sqlData || sqlData.length === 0) return { data: [] };

  // ヘッダーを取得
  const keys = Object.keys(sqlData[0]);

  // 列単位のデータを生成
  const data = keys.map((key) => sqlData.map((row) => row[key]));

  return { data };
}

export const TrainingPlayTime: React.FC<TrainingPlayTimeProps> = ({ data }) => {
  const dataList = data || [];
  const plotlyData = transformToPlotlyData(dataList);

  const graphData: any[] = [
    {
      type: 'histogram',
      x: plotlyData.data[0],
      marker: {
        color: `${Const.GraphBaseColor}`, // ヒストグラムの色（RGBA形式）
        line: {
          color: `${Const.BackGroundMainColor}`, // バーの枠線の色
          width: 1, // 枠線の幅
        },
        textfont: {
          size: 20, // 数値のフォントサイズを指定
        },
      },
    },
  ];

  if (dataList.length === 0) return <></>;

  return (
    <>
      <details className="rounded-3xl shadow-custom-lg overflow-hidden bg-white ml-2 mr-4 mt-2 mb-8">
        <summary className="cursor-pointer px-4 py-3 text-4xl">再生時間分布</summary>
        <Plot
          data={graphData}
          layout={{
            xaxis: {
              title: {
                text: '再生時間（秒）', // X軸の単位
                font: { size: 20 }, // X軸タイトルのフォントサイズ
              },
              tickfont: {
                size: 20, // X軸の値のフォントサイズを指定
              },
            },
            yaxis: {
              title: {
                text: '人数', // Y軸の単位
                font: { size: 20 }, // Y軸タイトルのフォントサイズ
              },
              tickfont: {
                size: 20, // Y軸の値のフォントサイズを指定
              },
              automargin: true,
              // tickformat: ",d", // 整数形式で表示
            },
            margin: {
              t: 20, // 上部のマージンを確保
              l: 50, // 必要最小限の左マージン
              r: 40,
              b: 80,
            },
            autosize: true,
          }}
          config={{
            responsive: true, // レスポンシブデザインを有効にする
            displayModeBar: false, // モードバーを非表示にする
            displaylogo: false, // Plotlyロゴを非表示にする
            staticPlot: true, // プロットを静的にする
          }}
          style={{ width: '100%', height: '100%', minHeight: '450px' }}
        />
      </details>
    </>
  );
};
